/**
 * @file assign-rep-modal.tsx
 * @module app/modals/assign-rep-modal
 * @description Renders the assign rep modal modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import Modal from "react-bootstrap/Modal";
import CrossSvg from "../../_admin/assets/media/close.png";
import { Button, Col, Row } from "react-bootstrap";

const AssignRepModal = (props: any) => {
  const { show, onHide, onConfirm, pendingAssignment, loading, roleTypeWarning } = props;

  const isBulk = pendingAssignment?.isBulk;
  const customerDisplay = isBulk 
    ? `${pendingAssignment?.customerId?.length} customer selected` 
    : (pendingAssignment?.customerName || "Selected Customer");

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-dialog-centered min-w-lg-500px"
      className="border-r10px"
    >
      <Modal.Header className="border-bottom-0 pb-0 position-relative">
        <div 
          className="position-absolute top-0 start-0 mt-6 ms-6 bg-light d-flex align-items-center justify-content-center cursor-pointer" 
          style={{ width: '36px', height: '36px', borderRadius: '50%' }}
          onClick={onHide}
        >
          <img
            width={40}
            height={40}
            src={CrossSvg}
            alt="close"
          />
        </div>
        <Modal.Title className="fs-22 fw-bolder text-dark w-100 text-center pt-5">
          Assign Rep
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="px-10 py-8">
        <div className="mb-7">
          <label className="fs-15 fw-bold text-gray-800 mb-3 d-block">Customer</label>
          <div className="bg-light border-0 rounded-3 px-5 py-4 fs-16 fw-500 text-dark">
            {customerDisplay}
          </div>
        </div>

        <div className="mb-10">
          <label className="fs-15 fw-bold text-gray-800 mb-3 d-block">Select Rep</label>
          <div className="custom-select-wrapper">
             {props.children}
          </div>
        </div>

        {roleTypeWarning && (
          <div className="alert alert-warning mb-7 border-0 rounded-3" role="alert">
            <span className="fs-15 fw-500 text-black">{roleTypeWarning}</span>
          </div>
        )}

        <div className="text-center">
          <Button
            variant="primary"
            className="uw-btn uw-btn-primary w-100 fs-16 fw-bold py-4 rounded-3"
            onClick={onConfirm}
            disabled={loading || (!pendingAssignment?.rep && isBulk)}
          >
            {!loading ? (
              <span>Assign Rep to Customers</span>
            ) : (
              <span>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AssignRepModal;
